import { combineReducers } from "redux";
import { burgerReducer } from "./reducers/burgerReducer";
import { logReducer } from "./reducers/logReducer";
import { modalActiveUserReducer } from "./reducers/modalActiveUser";

const rootReducers = combineReducers({
  burgerReducer,
  logReducer,
  modalActiveUserReducer,
});

export default rootReducers;
